import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  values, reduce, omit,
  delay, map, each, find, indexOf,
  lowerCase,
} from 'lodash';

import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import { Modal, Button } from 'react-bootstrap';
import { getTruVoiceClientsLoading, getTruVoiceClientsLoaded, getTruVoiceClients } from '../../AdminReducer';
import ProgressBar from '../../../../components/progress-bar';
import SearchField from '../../../../components/search-field';
import WindowResizeListener from '../../../../components/window-size-listener';
import ProgramRenderer from './ProgramRenderer';
import styles from './styles.css';

function GroupRowInnerRenderer(props) {
  const { value } = props;
  if (!value) {
    return null;
  }
  return (
    <span>Client: <strong>{value}</strong></span>
  );
}
GroupRowInnerRenderer.propTypes = {
  value: PropTypes.string,
};
GroupRowInnerRenderer.defaultProps = {
  value: null,
};

class TruVoiceClientsAssignModal extends Component {
  constructor() {
    super();
    this.state = {
      containerWidth: 0,
      included: null, // 'excluded', 'assigned'
      allPrograms: [],
      selectedRows: [],
    };
    this.onWindowResize = this.onWindowResize.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleIncluded = this.toggleIncluded.bind(this);
    
    this.handleSearch = this.handleSearch.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.isExternalFilterPresent = this.isExternalFilterPresent.bind(this);
    this.doesExternalFilterPass = this.doesExternalFilterPass.bind(this);
  }

  componentDidMount() {
    const nextOrg = this.props.organization || {};

    const selectedClients = nextOrg.tru_voice_clients;
    const selectedRows = [];
    const allPrograms = reduce(this.props.truVoiceClients, (items, client) => {
      const selectedClient = find(selectedClients, { client_id: client.client_id });
      each(client.programs, (program) => {
        items.push({
          ...program,
          client: omit(client, ['programs']),
          _id: `${client.client_id}.${program.program_id}`,
        });
        const selectedProgramIdx = selectedClient ? indexOf(selectedClient.program_ids, program.program_id) : -1;
        if (selectedClient !== undefined && selectedProgramIdx >= 0) {
          selectedRows.push({
            client_id: client.client_id,
            key: client.name, // hmm
            program_id: program.program_id,
          });
        }
      });
      return items;
    }, []);

    this.setState({ allPrograms, selectedRows, included: selectedRows.length > 0 ? 'assigned' : null });  // eslint-disable-line
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.onFirstDataRendered();
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { containerWidth } = this.state;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = containerWidth;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        const { selectedRows } = this.state;
        let firstNode = null;
        this.gridApi.forEachNode((node) => {
          const nodeData = node.data;
          if (nodeData) {
            const selectedRow = find(selectedRows, { client_id: nodeData.client.client_id, program_id: nodeData.program_id });
            const selected = selectedRow !== undefined;
            node.setSelected(selected);
          } else if (node.group) {
            const selectedRow = find(selectedRows, { key: node.key });
            if (selectedRow !== undefined) {
              if (!firstNode) {
                firstNode = node;
              }
              node.setExpanded(true);
            }
          } else {
            node.setSelected(false);
          }
        });

        if (firstNode) {
          this.gridApi.onFilterChanged();
        } else if (this.props.organization) {
          // there is no first node, we search by org name
          const orgName = lowerCase(this.props.organization.display_name || this.props.organization.name);
          let orgNode = null;
          this.gridApi.forEachNode((node) => {
            if (node.group && node.key && lowerCase(node.key) === orgName) {
              node.setExpanded(true);
              orgNode = node;
            }
          });
          if (orgNode) {
            this.gridApi.ensureIndexVisible(orgNode.rowIndex, 'top');
          }
        }
        this.gridApi.hideOverlay();
      }, 100);
    }
  }
  onWindowResize() {
    if (this.container) {
      this.setState({ containerWidth: this.container.offsetWidth });
    }
  }

  onRowSelected({ data }) {
    if (!data) {
      return;
    }
    this.gridApi.forEachNode((n) => {
      const nodeData = n.data;
      if (nodeData) {
        if (nodeData.client.client_id !== data.client.client_id) {
          n.setSelected(false);
        }
      }
    });
    const selected = this.gridApi.getSelectedRows();
    const selectedRows = reduce(selected, (results, item) => {
      results.push({
        key: item.client.name,
        client_id: item.client.client_id,
        program_id: item.program_id,
      });
      return results;
    }, []);
    
    this.setState({ selectedRows });
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  close() {
    this.setState({ selectedRows: [], included: null });
    this.props.onHide();
  }


  handleSubmit() {
    const { selectedRows } = this.state;
    const ids = reduce(selectedRows, (results, row) => {
      if (!results[row.client_id]) {
        results[row.client_id] = {
          client_id: row.client_id,
          program_ids: [],
        };
      }
      results[row.client_id].program_ids.push(row.program_id);
      return results;
    }, {});
    this.props.onClientChange(values(ids));
    this.close();
  }

  toggleIncluded(type) {
    const { included } = this.state;
    let newInclude = included;

    if (newInclude === type) {
      newInclude = null;
    } else {
      newInclude = type;
    }
    this.setState({ included: newInclude }, () => {
      if (this.gridApi) {
        this.gridApi.onFilterChanged();
      }
    });

  }

  isExternalFilterPresent() {
    return this.state.included !== null;
  }

  doesExternalFilterPass(node) {
    const clientIds = map(this.state.selectedRows, 'client_id');
    switch (this.state.included) {
      case 'assigned':
        return node.data && node.data.client && indexOf(clientIds, node.data.client.client_id) >= 0;
      case 'excluded':
        return node.data && node.data.client && indexOf(clientIds, node.data.client.client_id) < 0;
      default:
        return true;
    }
  }

  renderList() {
    const { allPrograms, included } = this.state;
    const {
      truVoiceClientsLoading, organization,
      truVoiceClientsLoaded,
    } = this.props;

    if (truVoiceClientsLoading || !truVoiceClientsLoaded) {
      return null;
    }
    if (allPrograms.length === 0) {
      return (
        <div className="alert alert-danger">
          No records found.
        </div>
      );
    }

    
    const columnDefs = [
      {
        headerName: 'Client',
        field: 'client.name',
        rowGroup: true,
        hide: true,
      },
      {
        headerName: 'TruVoice Program',
        field: 'name',
        colId: 'NAME',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 450,
        checkboxSelection: true,
        cellRenderer: ProgramRenderer,
        cellStyle: () => ({ paddingLeft: '40px' }),
      },
    ];

    return (
      <div ref={(el) => { this.container = el; }}>
        <div className="well">
          Select the clients below to map to <strong>{(organization.display_name || organization.name)}</strong>
        </div>
        <WindowResizeListener onResize={this.onWindowResize} />

        <nav className="navbar navbar-default navbar-controls">
          <div className="navbar-form pull-left">
            <SearchField onSearch={this.handleSearch} />
          </div>
          <div className="navbar-form pull-right" style={{ paddingTop: 5 }}>
            Show&nbsp;
            <div className="btn-group">
              <Button bsSize="xs" active={included === 'assigned'} onClick={() => { this.toggleIncluded('assigned'); }}>
                Assigned
              </Button>
              <Button bsSize="xs" active={included === 'excluded'} onClick={() => { this.toggleIncluded('excluded'); }}>
                Excluded
              </Button>
            </div>
            &nbsp;clients
          </div>
        </nav>
        <div className={`ag-theme-alpine ${styles.table}`} style={{ height: 400, width: '100%' }} >
          <AgGridReact
            reactNext
            enableSorting
            groupUseEntireRow
            columnDefs={columnDefs}
            rowData={allPrograms}
            onGridReady={this.onGridReady}
            animateRows
            groupDisplayType="groupRows"
            groupRowRendererParams={{
              innerRenderer: GroupRowInnerRenderer,
            }}
            onRowSelected={this.onRowSelected}
            rowMultiSelectWithClick
            singleClickEdit
            rowSelection="multiple"
            suppressRowClickSelection
            groupMultiAutoColumn
            rowDeselection
            getRowId={(params) => params.data._id}
            autoGroupColumnDef={{ headerName: ' CUSTOM! ', cellRendererParams: { suppressCount: true } }}
            isExternalFilterPresent={this.isExternalFilterPresent}
            doesExternalFilterPass={this.doesExternalFilterPass}
          />
        </div>
      </div>
    );
  }

  render() {
    const { show, truVoiceClientsLoading, truVoiceClientsLoaded } = this.props;
    const { allPrograms } = this.state;

    return (
      <Modal show={show} onHide={this.close} keyboard={false} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>TruVoice Clients Mapping</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {truVoiceClientsLoading && <ProgressBar />}
          {!truVoiceClientsLoading && truVoiceClientsLoaded && this.renderList()}
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button bsStyle="default" className="pull-left" onClick={this.close}>Cancel</Button>
            {allPrograms.length > 0 && <Button bsStyle="primary" className="pull-right" onClick={this.handleSubmit}>Save</Button>}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    truVoiceClients: getTruVoiceClients(state),
    truVoiceClientsLoading: getTruVoiceClientsLoading(state),
    truVoiceClientsLoaded: getTruVoiceClientsLoaded(state),
  };
}

TruVoiceClientsAssignModal.propTypes = {
  organization: PropTypes.shape({
    display_name: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onClientChange: PropTypes.func.isRequired,
  truVoiceClientsLoaded: PropTypes.bool.isRequired,
  truVoiceClientsLoading: PropTypes.bool.isRequired,
  truVoiceClients: PropTypes.shape({}).isRequired,
};
TruVoiceClientsAssignModal.defaultProps = {
  show: false,
};
export default connect(mapStateToProps)(TruVoiceClientsAssignModal);
